module.exports = __webpack_public_path__ + "media/Video 51.2e6dffe9.mp4";